export default __webpack_public_path__ + "static/media/img_baseCottonBunny_cotton.1a3d4d3b.jpg";